import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { CaretRight } from '@phosphor-icons/react';
import {
  trackRecaptureUpsellFlashClicked,
  trackArmUpsellFlashClicked,
} from '../../global/analytics';
import './upsellFlash.scss';

// Dashboard upsell tiles: one tile per product the admin's org can still buy,
// side by side at equal height. Each tile is a headline, one line and a
// button; Recapture is brand purple, ARM is ember so the pair reads as two
// products rather than one banner repeated. A lone tile spans the full width.
// Product decided these cannot be dismissed, so there is no close control and
// nothing is stored. Home passes only the products the org is eligible for.
export const PRODUCTS = {
  recapture: {
    id: 'recapture',
    to: '/app/recapture',
    tone: 'purple',
    ariaLabel: 'Learn more about Recapture',
    title: (
      <>
        Patient Recapture Agent,
        {' '}
        <em>automagically</em>
        {' '}
        keep your schedule full.
      </>
    ),
    subtitle: 'Books overdue patients back in. You only pay when they come back.',
    cta: 'Activate it now',
    trackClick: trackRecaptureUpsellFlashClicked,
  },
  arm: {
    id: 'arm',
    to: '/app/arm',
    tone: 'ember',
    ariaLabel: 'Learn more about ARM',
    title: (
      <>
        <em>Automated Referral Management</em>
        {' '}
        handles every referral as it comes in.
      </>
    ),
    subtitle: 'Patient texted seconds after the record arrives. You pay per scheduled referral.',
    cta: 'Get Started Today',
    trackClick: trackArmUpsellFlashClicked,
  },
};

const UpsellFlash = ({ products }) => {
  const tiles = products.flatMap((id) => (PRODUCTS[id] ? [PRODUCTS[id]] : []));
  if (tiles.length === 0) return null;

  return (
    <section className="upsell-flash" aria-label="New from Medsender">
      {tiles.map((product) => (
        <Link
          key={product.id}
          to={product.to}
          className={`upsell-flash-tile upsell-flash-tile--${product.tone}`}
          aria-label={product.ariaLabel}
          onClick={() => product.trackClick()}
        >
          <div className="upsell-flash-title">{product.title}</div>
          <div className="upsell-flash-subtitle">{product.subtitle}</div>
          <div className="upsell-flash-foot">
            <span className="upsell-flash-cta">
              <span>{product.cta}</span>
              <CaretRight size={16} weight="bold" />
            </span>
          </div>
        </Link>
      ))}
    </section>
  );
};

UpsellFlash.propTypes = {
  // Product ids to offer, in display order. Home passes only the products the
  // admin's org is eligible for (flag on, product not yet enabled).
  products: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(PRODUCTS))).isRequired,
};

export default UpsellFlash;
